export const OnNotificationEvent = "OnNotification";

export const OnBranchChangedEvent = "OnBranchChanged";
export const OnBranchesModifiedEvent = "OnBranchesModified";

export const OnApplicationAddedEvent = "OnApplicationAdded";
export const OnApplicationRemovedEvent = "OnApplicationRemoved";
export const OnApplicationChangedEvent = "OnApplicationChanged";
export const OnApplicationReadyEvent = "OnApplicationReady";

export const OnApplicationStartedEvent = "OnApplicationStarted";
export const OnApplicationRegisteredEvent = "OnApplicationRegistered";
export const OnApplicationAgmServerReadyEvent = "OnApplicationAgmServerReady";
export const OnApplicationUpdatedEvent = "OnApplicationUpdated";
export const OnApplicationStoppedEvent = "OnApplicationStopped";
export const OnApplicationStartFailedEvent = "OnApplicationStartFailed";
